import type * as core from '../../../../../core'

export const PACKAGE = {
  contents: [
    'resource:solutions.apps.dolomite',
    'resource:solutions.apps.dolomite.pages.chat',
    'resource:solutions.agents.dolomite',
  ],
  description: 'Dolomite',
  name: 'Dolomite',
} as const satisfies core.quiver.Package
